import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthRoutes } from '@core';
import { isNotAuthedGuard } from './application/guards/is-not-authed.guard';
import { LoginPage } from './pages/login/login.page';
import { RegisterPage } from './pages/register/register.page';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';
import { ResetPasswordSentPage } from './pages/reset-password-sent/reset-password-sent.page';
import { WelcomePage } from './pages/welcome/welcome.page';

const routes: Routes = [
  { path: AuthRoutes.WELCOME, component: WelcomePage, canActivate: [isNotAuthedGuard] },
  { path: AuthRoutes.LOGIN, component: LoginPage, canActivate: [isNotAuthedGuard] },
  { path: AuthRoutes.REGISTER, component: RegisterPage, canActivate: [isNotAuthedGuard] },
  { path: AuthRoutes.RESET_PASSWORD, component: ResetPasswordPage, canActivate: [isNotAuthedGuard] },
  { path: AuthRoutes.RESET_PASSWORD_SENT, component: ResetPasswordSentPage, canActivate: [isNotAuthedGuard] },
  { path: '', redirectTo: AuthRoutes.WELCOME, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
